<template>
  <resource-base
    :loading-display="false"
    :is-management-mode="isManagementMode"
    :display-activity="myAppSettings_isDisplayActivity"
    :display-settings="myAppSettings_isDisplaySettings"
    :resource="resource"
    :settings="settings"
    @appLog="appLog"
    @settings-gen-changed="handleSettingsGenChange"
    @update-settings="handleUpdateSettings"
  >
    <template v-slot:display>
      <b-container>
        <display :resource="resource" @appLog="appLog" />
      </b-container>
    </template>
    <template v-slot:activity>
      <activity :resource="resource" />
    </template>
    <template v-slot:settings>
      <settings
        :resource="resource"
        :settings="settings"
        @resource-updated="handleRefreshResource"
        @settings-user-changed="handleSettingsUserChange"
      />
    </template>
  </resource-base>
</template>

<script>
import ResourceBase from "../resourceBase";
import Display from "./sections/display";
import Activity from "./sections/activity";
import Settings from "./sections/settings";
import ResourceBlockIndex from "@/mixins/resourceBlocks/Index";
export default {
  name: "Resource_PlayList",
  mixins: [ResourceBlockIndex],
  components: {
    ResourceBase,
    Display,
    Activity,
    Settings
  },
  created() {
    this.handleSetUp();
  },
  props: {
    isManagementMode: {
      type: Boolean,
      default: false
    },
    resource: {
      type: Object,
      required: false,
      default: () => {}
    },
    settings: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  data() {
    return {
      appSetUp: {
        useBgImgClass: true,
        bgImgURL:
          "https://images.unsplash.com/photo-1694432586555-9a6dfe443600?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1325&q=80"
      },
      show: false,
      title: this.resource.name,
      imgURL: this.resource.imgURL,
      faIcon: this.resource.icon ? this.resource.icon : "fa-folder"
    };
  },
  methods: {
    handleSettingsChanged() {
      //move to mixin
      //console.log('refreshing resource');
      this.$emit("settings-change", settings);
    },
    handleRefreshResource() {
      //console.log('refreshing resource');
      this.$emit("refresh-publishing");
    },
    showResource() {
      this.show = true;
    },
    appLog(data) {
      //Use Mixins
      this.$emit("appLog", data);
    },
    handleSettingsUserChange(settings) {
      //can be a mixin
      this.$emit("settings-user-changed", settings);
    }
  }
};
</script>

<style lang="scss">
img {
  cursor: pointer;
}
</style>
